import styled, { css } from 'styled-components'

const Button = styled.button`
  background: transparent;
  border-radius: 3px;
  border: 1px solid #347EF6;
  color: #347EF6;
  padding-top: 7px;
  padding-bottom: 7px;
  padding-left:15px;
  padding-right:15px;

${props =>
    props.primary &&
    css`
        border-width: 1px;
        border-color: #347EF6;
        background-color: #347EF6;
        color: white;
        font-weight: 700;
    `};

${props => 
    props.shadow &&
    css`
        box-shadow: 0px 1px 3px grey;
    `}

${props => 
    props.block &&
    css`
        width: 100%;
    `}
${props => 
    props.borderless &&
    css`
        border-width: 0px;
    `}
${props => 
    props.disabled &&
    css`
        background-color: transparent;
        color: rgb(202,202,202);
        border-color: rgb(202,202,202);
    `}
${props =>
    props.greyed &&
    css`
        background-color: transparent;
        color: rgb(202,202,202);
        border-color: rgb(202,202,202);
    `}
${props =>
    props.flatLeftSide &&
    css`
        border-top-left-radius: 0px;
        border-bottom-left-radius: 0px;
    `}
${props =>
    props.flatRightSide &&
    css`
        border-top-right-radius: 0px;
        border-bottom-right-radius: 0px;
    `}

${props =>
    props.small &&
    css`
        padding-top: 5px;
        padding-bottom: 5px;
        padding-left: 5px;
        padding-right: 5px;
        font-size: 0.85em;
    `};

${props =>
    props.bold &&
    css`
        font-weight: 700;
    `};

${props =>
    props.payment &&
    css`
        border-color: #39C16C;
        background-color: #39C16C;
    `};
${props => 
    props.danger &&
    css`
        border-color: #ff5252;
        color: #ff5252;
    `};
${props => 
    props.dangerPrimary &&
    css`
        border-color: #ff5252;
        color: white;
        background-color: #ff5252;
        font-weight: 700;
    `};
${props => 
    props.smallText &&
    css`
        font-size: 0.857em;
    `};
    ${props => props.backgroundColor && css`
        background-color: ${props => props.backgroundColor};
    `}

${props => props.noWrap && css`
    white-space: nowrap;
`}

${props => props.minWidth && css`
    min-width: ${props => props.minWidth};
`}
${props => props.maxHeight && css`
    max-height: ${props => props.maxHeight};
`}
${props => props.margin && css`
    margin: ${props => props.margin};
`}
${props => props.maxWidth && css`
    max-width: ${props => props.maxWidth};
`}
`

export default Button